// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f4f4f9;
}

.content {
  flex-grow: 1;
  padding: 32px;
  padding-top: 125px; /* header height (105px) + spacing */
  transition: all 0.3s ease;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.shift-right {
  margin-left: 240px; /* Sidebar width */
  width: calc(100% - 240px);
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .content {
    padding: 24px;
    padding-top: 115px;
  }
}

@media (max-width: 960px) {
  .content {
    padding: 20px;
    padding-top: 105px;
  }
  
  .shift-right {
    margin-left: 0;
    width: 100%;
  }
}

@media (max-width: 600px) {
  .content {
    padding: 16px;
    padding-top: 95px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAE,oCAAoC;EACxD,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB,EAAE,kBAAkB;EACtC,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF","sourcesContent":[".App {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #f4f4f9;\n}\n\n.content {\n  flex-grow: 1;\n  padding: 32px;\n  padding-top: 125px; /* header height (105px) + spacing */\n  transition: all 0.3s ease;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.shift-right {\n  margin-left: 240px; /* Sidebar width */\n  width: calc(100% - 240px);\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .content {\n    padding: 24px;\n    padding-top: 115px;\n  }\n}\n\n@media (max-width: 960px) {\n  .content {\n    padding: 20px;\n    padding-top: 105px;\n  }\n  \n  .shift-right {\n    margin-left: 0;\n    width: 100%;\n  }\n}\n\n@media (max-width: 600px) {\n  .content {\n    padding: 16px;\n    padding-top: 95px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
